import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect, useState } from 'react';
import { useForm, useFormContext } from 'react-hook-form';
import { z } from 'zod';
import { RefineSearchCriteriaFormValues } from '../../../api/useSearchCriteria';
import { useIdentifiedListContext } from '../utils/IdentifiedListContext';
import UIStrings from '@/Utils/UIStrings';
import ValidationErrors from '@/Utils/ValidationErrors';

export const requiredRankingCriteriaError = 'requiredRankingCriteriaError';

export const refineSearchCriteriaFormValidator = z
    .object({
        rankingCriteria: z
            .array(
                z.object({
                    id: z.string(),
                    criterion: z
                        .string()
                        .min(1, ValidationErrors.Required)
                        .max(1024, { error: ({ maximum }) => UIStrings.MaxSymbolsValidationError(maximum) }),
                }),
            )
            .min(1)
            .max(5),
    })
    .superRefine(({ rankingCriteria }, context) => {
        if (rankingCriteria.some(({ criterion }) => criterion.length === 0)) {
            context.addIssue({
                code: 'custom',
                message: ValidationErrors.AISearchFillEveryRankingCriteriaRequired,
                path: [requiredRankingCriteriaError],
            });
        }
    });

export const useRefineSearchCriteriaForm = () => {
    const { refineSearchCriteria } = useIdentifiedListContext();
    const [disabled, setDisabled] = useState(false);
    const form = useForm<RefineSearchCriteriaFormValues>({
        mode: 'all',
        disabled,
        defaultValues: refineSearchCriteria,
        resolver: zodResolver(refineSearchCriteriaFormValidator),
    });

    useEffect(() => setDisabled(form.formState.isSubmitting), [form.formState.isSubmitting]);

    return form;
};

export const useRefineSearchCriteriaFormContext = () => useFormContext<RefineSearchCriteriaFormValues>();
